export enum COVER_ACTION {
  GENERATE = 'generate',
  UPLOAD = 'upload',
}